import React, { Component } from "react";
import "../css/import.css";
// import DatePicker from 'react-datepicker';
import moment from 'moment';
import XLSX from 'xlsx';

import 'react-datepicker/dist/react-datepicker.css';
import { ExportService } from "../Services/ExportService";

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
import { format_date_only } from "../Utils";

const styles = {
    grid: {
      width: '60%',
    },
  };
  


class Export extends Component {

    constructor(props) {
        super(props);
        this.state = {
            headers :['Name', 'ROUTE ID', 'ADDRESS', 'productName',	'productCategory', 'productUnitSize', 'RATE', 'totalAmount', 'NUMBER', 'fulfilledByVendor',	'userId',	'flatComparator', 'newCompleteFlatComparator', '$$hashKey',	'SCH', 'DEL', 'EMP', 'REMARKS', 'Agent name'],
            sheet: "DailyNinja_STORE_" + moment().format("DD_MMMM,YYYY"),
            filename: "IMPORT "+ moment().format("DD.MM.YY"),
            datePickerDate: moment()
        }
    
        this.handleDateChange = this.handleDateChange.bind(this);
        this.exportFile = this.exportFile.bind(this);
    }

    exportFile(e) {
        let schedules = [[moment(this.state.datePickerDate).format("DD.MM.YY")],this.state.headers];
        this.props.isLoading(true);
        ExportService.export(this.state.datePickerDate)
        .then((data) => {
            data.report.forEach((sch) => {
                let scheduleArray = [sch.name, sch.route_id, sch.address,sch.productname,sch.productcategory,sch.productunitsize,sch.rate,sch.totalamount,sch.number,sch.fullfilledbyvendor,sch.userid,sch.flatComparator,sch.newCompleteFlatComparator,sch.hashKey,sch.SCH,sch.DEL,sch.EMP,sch.REMARKS,sch.agentname]
                schedules.push(scheduleArray)
            });

            const wb = XLSX.utils.book_new();
            const wsAll = XLSX.utils.aoa_to_sheet(schedules);
            XLSX.utils.book_append_sheet(wb, wsAll, this.state.sheet.substring(0, 30));
            XLSX.writeFile(wb, this.state.filename + ".xlsx");

            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleDateChange(date){
        this.setState({
            datePickerDate: date,
            filename: "IMPORT "+ moment(date).format("DD.MM.YY"),
            sheet: "DailyNinja_STORE_" + moment().format("DD_MMMM,YYYY")
          });
    }

    render() {
        return (
            <div className="Home">
                <div className="container">
                    <h3 style={{marginBottom: '20px'}}>Download Tally Export file</h3>
                    <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: "15px"}}>
                        <div>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Export Date"
                                    value={this.state.datePickerDate}
                                    onChange={this.handleDateChange}
                                    format={format_date_only}
                                    style={{height: "100%"}}
                                />
                            </MuiPickersUtilsProvider>
                            <Button style={{marginTop: '20px', marginLeft: '20px'}} variant="outlined" size="medium" color="primary" onClick={this.exportFile}>Download</Button>
                        </div>
                    </Paper>
                </div>
        </div>
        );
    }
}

export default withStyles(styles)(Export);